import React from 'react'
import {useParams} from 'react-router-dom'
import {PartnerDisputeManagementPage} from '../UI/bulk-vos/PartnerDisputeManagementPage'

export function BulkVosPublicPage() {
  const {token} = useParams<{token: string}>()
  return <PartnerDisputeManagementPage token={token} />
}
